function StarIcon(props: React.ComponentPropsWithoutRef<'svg'>) {
    return (
        <svg aria-hidden='true' viewBox='0 0 20 20' {...props}>
            <path d='M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z' />
        </svg>
    );
}

interface Opts {
    rating?: number;
    colors?: { filled: string; empty: string };
    size?: 'small' | 'large';
}

export function StarRating(
    { rating = 5, colors = { filled: 'fill-yellow-300', empty: 'fill-gray-300' }, size = 'large' }: Opts,
) {
    const height = size === 'small' ? 'h-3' : 'h-5';
    const width = size === 'small' ? 'w-3' : 'w-5';
    return (
        <div className='flex gap-1'>
            {[ ...Array(5).keys() ].map((index) => {
                const fillPercentage = Math.min(1, Math.max(0, rating - index));

                if (fillPercentage === 1) {
                    return <StarIcon key={index} className={`${height} ${width} ${colors.filled}`} />;
                }

                if (fillPercentage === 0) {
                    return <StarIcon key={index} className={`${height} ${width} ${colors.empty}`} />;
                }

                // Partial fill
                return (
                    <div key={index} className={`relative ${height} ${width}`}>
                        <StarIcon className={`absolute ${height} ${width} ${colors.empty}`} />
                        <div
                            className={`absolute ${height} overflow-hidden`}
                            style={{ width: `${fillPercentage * 100}%` }}
                        >
                            <StarIcon className={`${height} ${width} ${colors.filled}`} />
                        </div>
                    </div>
                );
            })}
        </div>
    );
}
